import { RootStateType } from 'App/store';
import createSimpleSelector from 'commons/utils/createSimpleSelector';

export const getDashboard = (state: RootStateType) => state.dashboard;

const getUsersEntity = createSimpleSelector(
  [getDashboard],
  (dashboard) => dashboard.users,
);

const getForwardConfirmationEmailEntity = createSimpleSelector(
  [getUsersEntity],
  (users) => users.forwardConfirmationEmail,
);

export const getforwardConfirmationEmailStatus = createSimpleSelector(
  [getForwardConfirmationEmailEntity],
  (forwardConfirmationEmail) => forwardConfirmationEmail.status,
);

const getCloudflareDismissCheckEntity = createSimpleSelector(
  [getUsersEntity],
  (users) => users.cloudflareDismissCheck,
);

export const getCloudflareDismissCheckStatus = createSimpleSelector(
  [getCloudflareDismissCheckEntity],
  (cloudflareDismissCheck) => cloudflareDismissCheck.status,
);

export const getCloudflareDismissCheckData = createSimpleSelector(
  [getCloudflareDismissCheckEntity],
  (cloudflareDismissCheck) => cloudflareDismissCheck.data,
);
